import(/* webpackMode: "eager" */ "/home/runner/work/kuden-legend/kuden-legend/frontend/business/src/app/(beforeLogin)/privacypolicy/page.tsx");
